<template>
  <div class="experiences">
    <div class="label f8">{{ $t("Select Experience") }}</div>
    <div class="experiencegrid">
      <div class="experience" v-for="experience in experiences" :key="experience.id">
        <UIButton
          :ghost="true"
          :class="{ '-active': isExperienceSelected(experience) }"
          :disabled="!hasStations(experience)"
          @click="$emit('experienceAction', experience)"
        >{{ experience.title }}</UIButton>
        <div v-if="!hasStations(experience)" class="message f7">{{ $t('No Stations') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    UIButton,
  },
  props: {
    bookingStationTime: {
      type: Object,
      required: true,
    },
    experiences: {
      type: Array,
      required: true,
    },
    stations: {
      type: Array,
      required: true,
    },
  },
})
export default class Experience extends Vue {
  isExperienceSelected (experience) {
    return this.bookingStationTime.experience.id === experience.id;
  }

  hasStations (experience) {
    return this.stations.filter(station => station.experience.id === experience.id).length > 0;
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.experiences {
  & .label {
    margin-bottom: var(--spacingXS);
  }

  & .experiencegrid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: var(--spacingXS);
    width: 100%;

    @media (--tablet) {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: var(--spacingSm);
    }

    @media (--desktop) {
      grid-gap: var(--spacingMd);
      grid-template-columns: repeat(3, 1fr);
    }

    & .experience {
      & >>> button {
        width: 100%;
        white-space: normal;
      }

      & .message {
        text-align: center;
      }
    }
  }
}
</style>
